import { isBefore, sub } from 'date-fns';
import { ofType } from 'redux-observable';
import { Observable, of } from 'rxjs';
import { filter, mergeMap, take, withLatestFrom } from 'rxjs/operators';
import { VenueConfirmationStorage } from '@bridebook/web/lib/storage-manager/basic/venue-confirmation';
import { IEpicDeps } from '@bridebook/web/lib/types';
import { triggerBookingConfirmationModal } from '@bridebook/web/lib/venue-confirmation/actions';
import { IUpdateWeddingAction, WeddingActionTypes } from '@bridebook/web/lib/weddings/action-types';
import { getVenueBooked } from '@bridebook/web/lib/weddings/selectors';

export const openVenuePopupAfterTimePeriod = (
  action$: Observable<IUpdateWeddingAction>,
  { state$ }: IEpicDeps,
): Observable<any> =>
  action$.pipe(
    ofType(WeddingActionTypes.UPDATE_WEDDING),
    withLatestFrom(state$),
    filter(([, state]) => !!state.users.user),
    take(1),
    mergeMap(([, state]) => {
      const isOldAccount = isBefore(
        state.users.user?.registeredAt as number,
        sub(Date.now(), { months: 2 }),
      );
      const venueBooked = getVenueBooked(state);
      const popupShownDate = VenueConfirmationStorage.get();

      const minTwoWeeksPassed = popupShownDate
        ? isBefore(new Date(popupShownDate), sub(Date.now(), { weeks: 2 }))
        : true;

      if (isOldAccount && !venueBooked && minTwoWeeksPassed) {
        return of(
          triggerBookingConfirmationModal({
            showIntro: true,
            location: 'venueConfirmationReminder',
            searchSupplierType: 'venue',
          }),
        );
      }

      return of();
    }),
  );
